import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const ReportFieldListDetails = () => {
  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'Field Type', value: 'data_type' }, // Mapped to data_type
    { label: 'Report', value: 'report' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];

  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/reporting/report-field/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['reportField']} />;
};

export default ReportFieldListDetails;